export default __webpack_public_path__ + "static/media/loading-transparent.75d56745.gif";